const DICTIONARIES_ACTION_TYPES = {
  FETCH: "FETCH_DICTIONARY",
  FETCH_REQUEST: "FETCH_DICTIONARY_REQUEST",
  FETCH_SUCCESS: "FETCH_DICTIONARY_SUCCESS",
  FETCH_FAILURE: "FETCH_DICTIONARY_FAILURE",
}

export default DICTIONARIES_ACTION_TYPES
